import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Box, Typography } from '@mui/material';

const TaskCompletionRadialChart = ({ data = [] }) => {
    // Use API data if available, otherwise use default values
    const series = data ? [
        data?.completed || 0,
        data?.inProgress || 0,
        // data?.remaining || 0
    ] : [0, 0, 0];
    const options = {
        chart: {
            type: 'radialBar',
        },
        plotOptions: {
            radialBar: {
                offsetY: 0,
                startAngle: 0,
                endAngle: 270,
                hollow: {
                    margin: 5,
                    size: '45%',
                },
                track: {
                    strokeWidth: '100%', // base track
                },
                dataLabels: {
                    name: {
                        show: true,
                    },
                    value: {
                        show: true,
                    },
                },
            },
        },
        stroke: {
            lineCap: 'round',
            width: 2, // 👈 Increase this for thicker lines
        },
        labels: ['Completed', 'In Progress'],
        colors: ['#2e7d32', '#9e9e9e'],
        legend: {
            show: true,
            floating: false,
            position: 'right',
            offsetX: 10,
            offsetY: 10,
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                    },
                },
            },
        ],
    };

    return (
        <Box>
            <Typography variant="h6" mb={2}>
                Tasks Completion Trends
            </Typography>
            <ReactApexChart options={options} series={series} type="radialBar" height={400} width={400} />
        </Box>
    );
};

export default TaskCompletionRadialChart;
